import {
  GetSchedulePostParams,
  ResponseGetSchedulePost,
  PostsEndpoints,
  PostsService
} from 'src/services/posts';

import useRequest from '../useRequest';
import { REQUEST_CONFIG } from './useGetScheduledPost.constants';

export const useGetScheduledPost = (params: GetSchedulePostParams) => {
  return useRequest<ResponseGetSchedulePost>(
    PostsEndpoints.getSchedulePost(params.postId),
    () => PostsService.getSchedulePost(params),
    {
      enabled: Boolean(params?.isEnabled),
      ...REQUEST_CONFIG
    }
  );
};
